<template>
  <div class="page-status">
    <div class="page-status-loading" v-if="loading">
      <van-loading color="#108ee9">加载中...</van-loading>
    </div>
    <div class="page-status-empty" v-else-if="empty">
      <van-empty description="暂无数据" />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  props: ['loading', 'empty'],
};
</script>

<style lang="less">
.page-status {
  &-loading {
    padding: 200px 0;
    text-align: center;
  }
}
</style>
